//export const BaseUrl = "http://huayi.wodiantech.com";
//export const BaseUrl = "./";
//export const BaseUrl = "https://10.33.230.36";
//export const BaseUrl = "https://zhhb.shhuayi.com:1443";
export const BaseUrl = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`;
//export const BaseUrl = "http://localhost:8091";